import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { X, History } from 'lucide-react';
import { api } from '../lib/api';

const fmt = (iso) => new Date(iso).toLocaleString('fr-FR', { weekday: 'short', day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });

// Founders : ce qu'un invité admin a modifié, avec date et heure.
export default function AdminAuditDialog({ guest, onClose }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get('/admin-audit', { params: { guest_id: guest.id } }).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [guest.id]);
  return createPortal(
    <div data-testid="admin-audit-dialog" onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 200, background: 'rgba(6,12,26,0.78)', backdropFilter: 'blur(14px)', display: 'grid', placeItems: 'center', padding: 14 }}>
      <div onClick={(e) => e.stopPropagation()} className="scale-in" style={{ width: '100%', maxWidth: 560, maxHeight: '86vh', overflowY: 'auto', borderRadius: 20, padding: 20, background: 'linear-gradient(180deg, rgba(20,29,66,0.92) 0%, rgba(14,22,44,0.98) 100%)', border: '1px solid var(--bd)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
          <History size={18} color="#F5C56A" />
          <div style={{ flex: 1, fontFamily: 'Sora', fontWeight: 800, fontSize: 16, color: 'var(--t1)' }}>Historique · {guest.name}</div>
          <button data-testid="admin-audit-close" onClick={onClose} style={{ background: 'transparent', border: '1px solid var(--bd)', borderRadius: 9, padding: 7, color: 'var(--t2)', cursor: 'pointer' }}><X size={14} /></button>
        </div>
        {!rows ? <div style={{ fontFamily: 'Sora', color: 'var(--t3)', fontSize: 13 }}>Chargement…</div>
          : rows.length === 0 ? <div data-testid="admin-audit-empty" style={{ fontFamily: 'Sora', color: 'var(--t3)', fontSize: 13 }}>Aucune modification pour l&apos;instant.</div>
            : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {rows.map((r) => (
                  <div key={r.id} data-testid={`admin-audit-row-${r.id}`} style={{ display: 'flex', gap: 12, padding: '9px 12px', borderRadius: 11, background: 'rgba(255,255,255,0.03)', border: '1px solid var(--bd)' }}>
                    <span style={{ fontFamily: 'Sora', fontWeight: 700, fontSize: 11, color: 'var(--t3)', minWidth: 118, textTransform: 'capitalize' }}>{fmt(r.at)}</span>
                    <span style={{ fontFamily: 'Lexend', fontSize: 12.5, color: 'var(--t1)' }}>{r.action}{r.target ? <b style={{ color: '#F5C56A' }}> · {r.target}</b> : null}</span>
                  </div>
                ))}
              </div>
            )}
      </div>
    </div>,
    document.body,
  );
}
